import { render, staticRenderFns } from "./DirectMailrRevenue.vue?vue&type=template&id=3c9ae7a4&"
import script from "./DirectMailrRevenue.vue?vue&type=script&lang=js&"
export * from "./DirectMailrRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports